export default {"icons":{"iconfont":"mdiSvg"},"options":{"customProperties":true},"theme":{"options":{"minifyTheme":function (css) {
  return css.replace(/\n/g, '').replace(/\s\s+/g, ' ');
}},"themes":{"light":{"normal":"#999999","primary":"#15BEAE","secondary":"#efeff4","error":"#F05151"}}}}
